import toast from 'react-hot-toast'

/**
 * Toast工具类
 * 添加依赖 "react-hot-toast": "^2.4.1",
 * 首页添加  <Toaster />
 */
class ToastUtils {

    // loading
    static showLoading(isLoading: boolean, msg: string = 'loading...') {
        if (isLoading) {
            toast.loading(msg, {
                id: "loading",
                position: 'top-center',
                duration: 0,
                className: "w-dvw text-start font-semibold",
                style: {
                    background: '#F5F6F9',
                    color: "#000",
                    margin: '12px 24px',
                },
            });
        } else {
            toast.dismiss("loading");
        }
    }

    static dismissLoading() {
        toast.dismiss("loading");
    }

    /// 显示Toast
    static showToast(msg: string, duration?: number, textColor = "#fff", type = "msg") {
        toast(msg, {
            id: type,
            position: 'top-center',
            duration: duration || 2000,
            className: "w-dvw text-center font-semibold",
            style: {
                // background: '#333',
                color: textColor,
                margin: '12px 24px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '4px',
                padding: '10px 16px',
            },
            icon: type === "success" ? "👍" : type === "fail" ? "❌" : undefined,
        })
    }

    /// 显示成功Toast
    static showToastSuccess(msg: string, duration?: number,) {
        this.showToast(msg, duration, "#3EE76E", "success");
    }

    /// 显示失败Toast
    static showToastFail(msg: string, duration?: number) {
        this.showToast(msg, duration, "#FF4264", "fail");
    }
}

export default ToastUtils